import { Component } from '@angular/core';

@Component({
  selector: 'app-pbi-connection-page',
  templateUrl: './pbi-connection-page.component.html',
  styleUrls: ['./pbi-connection-page.component.scss']
})
export class PbiConnectionPageComponent {


  constructor() { }



}
